import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import Checkbox from '@material-ui/core/Checkbox';

import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';


const pageSizes = [5, 10, 25, 50, 100];
const searchBy = [
    { key: 'Report Title', value: 'title' },
    { key: 'Requested By', value: 'requested_by' },
    { key: 'Requested Date', value: 'requested_date' },
    { key: 'Report Date', value: 'dates' },
];



export function MaterialUIPickers(props) {
    
    var date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth();
    var firstDay = new Date(),
        y = date.getFullYear(),
        m = date.getMonth();

const [selectedDate, setSelectedDate] = React.useState(firstDay);

const handleDateChange = (date) => {
    setSelectedDate(date);
    props.setDate(date);
};

return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container justifyContent="space-around">
            <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="none"
                id={props.id}
                label={props.label}
                value={selectedDate}
                onChange={handleDateChange}
                maxDate={new Date()}
                autoOk={true}
                KeyboardButtonProps={{
                    'aria-label': 'change date'
                }}
            />
        </Grid>
    </MuiPickersUtilsProvider>
);
}

class GCArchive extends React.Component {
    _isMounted = false;
    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_from_date:this.getFormattedDate(new Date()),
        search_to_date:this.getFormattedDate(new Date()),
        search_created_date:this.getFormattedDate(new Date()),
        search_by: 'title',
        alert: 0,
        alertMessage: '',
        data: [],
        selectedItem: [],
        flag: true,
        
    };


    getFormattedDate(date) {
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData(330);
    }
    
    downloadReport= (seelctedItem) => {
        //console.log(seelctedItem)
    }
    async loadData(catID) {
        
        if (this._isMounted) {
            this.setState({showLoading: true });
        }
        if(this.state.search_by == 'requested_date' || this.state.search_by == 'dates'){
            var search_key = 'requested_date'
        }else{
            var search_key = this.state.search_key
        }
        let bodyData = {
            search_key: search_key,
            search_by: this.state.search_by,
            search_created_date: this.state.search_created_date,
            search_from_date: this.state.search_from_date,
            search_to_date: this.state.search_to_date,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo,
            MasterGiftCard:this.props.MasterGiftCard.title
        };
       //console.log(bodyData)
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'giftcards/getGCReports'
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                    //console.log(responseData)
                    
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            showLoading: false,
                            alert: 0,
                            alertMessage: '',
                            data:responseData.data,
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                        });
                    }
                
                
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData(330);
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData(330);
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData(330);
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadData(330);
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData(330);
            }, 500);
        }
    };

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    
    
    render() {
        const options = {
            actionsColumnIndex: -1
        };

        
        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}
                {this.state.showLoading && <Spinner animation="border" />}

                
                            <div>
                                <hr />
                            </div>
                            <Row style={{ justifyContent: 'right' }}>
                                <Col
                                    style={{
                                        justifyContent: 'right',
                                        textAlign: 'right'
                                    }}
                                >
                                    <Form.Group
                                        as={Row}
                                        style={{
                                            justifyContent: 'right',
                                            marginRight: '0'
                                        }}
                                    >
                                        <select
                                            className="form-control"
                                            style={{ width: 'auto' }}
                                            name="search_by"
                                            onChange={this.onChangeValues}
                                            value={this.state.search_by}
                                        >
                                            {searchBy.map((search) => (
                                                <option
                                                    key={search.value}
                                                    value={search.value}
                                                >
                                                    Search By {search.key}
                                                </option>
                                            ))}
                                        </select>
                                        {this.state.search_by !=='name' && this.state.search_by !=='requested_by' && this.state.search_by !=='requested_date' && this.state.search_by =='dates' &&<Row style={{ marginLeft: '0px',marginRight: '0px' }}>
                                    <Col>
                                        <MaterialUIPickers
                                id="date-picker-inline1"
                                label="From Date"
                                setDate={(date) => {
                                    this.setState({
                                        search_from_date: this.getFormattedDate(date)
                                    });
                                }}
                            />
                            </Col>
                            <Col>
                                    <MaterialUIPickers
                                id="date-picker-inline2"
                                label="To Date"
                                setDate={(date) => {
                                    this.setState({
                                        search_to_date: this.getFormattedDate(date)
                                    });
                                }}
                            />
                            </Col>
                                    </Row>}

                                    {this.state.search_by !=='name' && this.state.search_by !=='requested_by' && this.state.search_by =='requested_date' && this.state.search_by !=='dates' &&<Row style={{ marginLeft: '0px',marginRight: '0px' }}>
                                   
                            <Col>
                                    <MaterialUIPickers
                                id="date-picker-inline2"
                                label="To Date"
                                setDate={(date) => {
                                    this.setState({
                                        search_created_date: this.getFormattedDate(date)
                                    });
                                }}
                            />
                            </Col>
                                    </Row>}

                                    {this.state.search_by !=='requested_date' && this.state.search_by !=='dates' &&<Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />}
                                        <Button
                                            variant="primary"
                                            onClick={this.submitSearch}
                                        >
                                            Search
                                        </Button>

                                        <Button
                                            style={{ marginLeft: '1rem' }}
                                            variant="primary"
                                            onClick={this.restSearch}
                                        >
                                            Reset
                                        </Button>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <MaterialTable
                                components={{
                                    Pagination: PatchedPagination
                                }}
                                title={"Reports"}
                                columns={[
                                    {
                                        title: 'Title',
                                        field: 'title',
                                        
                                    },
                                    {
                                        title: 'Requested Date',
                                        field: 'created_date',
                                        
                                    },
                                    {
                                        title: 'Requested By',
                                        field: 'userName',
                                        
                                    },
                                    
                                    {
                                        title: 'From Date',
                                        field: 'from_date',
                                        
                                    },
                                    
                                    {
                                        title: 'To Date',
                                        field: 'to_date',
                                        
                                    },
                                    {
                                        title: 'Action',
                                        field: 'status',
                                        render: (row) => (
                                            <div>
                                                <Button
                                                    variant="primary"
                                                    onClick={(e) =>this.downloadReport(row)}
                                                >
                                                    Download
                                                </Button>
                                            </div>
                                        )
                                        
                                    },
                                    
                                ]}
                                data={this.state.data}
                                options={{
                                    filtering: false,
                                    search: false,
                                    sorting: false,
                                    paging: false,
                                    actionsColumnIndex: -1
                                }}
                            />

                            <div>
                                <hr />
                            </div>
                            <Row className="custom_pagination">
                                {this.state.StartAt.length > 1 && (
                                    <Col>
                                        <Button
                                            onClick={this.paginatePrev}
                                            variant="primary"
                                        >
                                            Prev
                                        </Button>
                                    </Col>
                                )}
                                {this.state.StartAt.length < 2 && (
                                    <Col>
                                        <Button
                                            variant="secondary"
                                            disabled={true}
                                        >
                                            Prev
                                        </Button>
                                    </Col>
                                )}

                                <Col style={{ textAlign: 'center' }}>
                                    {'Items per page:'}
                                    <select
                                        className="items_per_page"
                                        onChange={this.handlePageSizeChange}
                                        value={this.state.perPage}
                                    >
                                        {pageSizes.map((size) => (
                                            <option key={size} value={size}>
                                                {size}
                                            </option>
                                        ))}
                                    </select>
                                    Page: {this.state.StartAt.length}
                                </Col>

                                <Col style={{ textAlign: 'right' }}>
                                    {this.state.data.length <
                                        this.state.perPage && (
                                        <Button
                                            variant="secondary"
                                            disabled={true}
                                        >
                                            Next
                                        </Button>
                                    )}

                                    {this.state.data.length >=
                                        this.state.perPage && (
                                        <Button
                                            onClick={this.paginateNext}
                                            variant="primary"
                                        >
                                            Next
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        
                           


            </Container>
        );
    }
}

export default GCArchive;
